/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { DriversService } from './services/drivers.service';
import { PackagesService } from './services/packages.service';
import { QrCodeService } from './services/qr-code.service';
import { UserService } from './services/user.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [DriversService, PackagesService, QrCodeService, UserService, ApiConfiguration],
})
export class PtApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PtApiModule> {
    return {
      ngModule: PtApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: PtApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('PtApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
